<template>
  <div class="subhead-common">
    <div class="left" :style="{ background: backgroundColor }"></div>
    <div class="right">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "#005196",
    },
    title: {
      type: String,
      default: "小标题",
    },
  },
  name: "subhead",
};
</script>

<style lang="less">
.subhead-common {
  height: 14px;
  line-height: 14px;
  .left,
  .right {
    float: left;
  }
  .left {
    width: 3px;
    height: 14px;
    margin-right: 10px;
  }
  .right {
    color: #333333;
  }
}
</style>